"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _commonMediaQuery = require("@mmc/common-media-query");

var _commonShareDialog = require("./common-share-dialog.prop-types");

var _commonShareSocial = _interopRequireDefault(require("./common-share-social.css"));

var _commonShareDialog2 = require("./common-share-dialog.utils");

var CommonShareSocial = function CommonShareSocial(_ref) {
  var className = _ref.className,
      _native = _ref["native"],
      email = _ref.email,
      facebook = _ref.facebook,
      shareLabel = _ref.shareLabel,
      theme = _ref.theme,
      twitter = _ref.twitter,
      text = _ref.text,
      url = _ref.url;
  var isSupportShareNative = (0, _commonMediaQuery.isMobileAgent)() && typeof window.navigator !== 'undefined' && window.navigator.share;

  var handleShareNativeClick = function handleShareNativeClick() {
    if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined' && window.navigator.share) {
      return window.navigator.share({
        title: _native.text,
        url: _native.url
      });
    }
  };

  var mailShareURL = email && (0, _commonShareDialog2.objectToGetParams)({
    subject: email.subject,
    body: email.text
  });
  var infoFacebookShare = text && url && (0, _commonShareDialog2.objectToGetParams)({
    u: url,
    quote: text
  });
  var infoTwitterShare = text && url && (0, _commonShareDialog2.objectToGetParams)({
    url: url,
    title: text
  });
  var facebookShareURL = facebook && (0, _commonShareDialog2.objectToGetParams)({
    u: facebook.url,
    quote: facebook.text
  }) || infoFacebookShare;
  var twitterShareURL = twitter && (0, _commonShareDialog2.objectToGetParams)({
    url: twitter.url,
    title: twitter.text
  }) || infoTwitterShare;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme.black, _commonShareSocial["default"].shareSocial, className)
  }, _native && isSupportShareNative ? /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: _commonShareSocial["default"].label,
    onClick: handleShareNativeClick
  }, shareLabel) : /*#__PURE__*/_react["default"].createElement("p", {
    className: _commonShareSocial["default"].label
  }, shareLabel), mailShareURL && /*#__PURE__*/_react["default"].createElement("a", {
    href: "mailto:?" + mailShareURL
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: (0, _clsx["default"])(_commonShareSocial["default"].icon, theme.mmcIconEmail)
  })), twitterShareURL && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: _commonShareSocial["default"].shareBtn,
    onClick: function onClick() {
      return (0, _commonShareDialog2.openWindow)("https://twitter.com/share?" + twitterShareURL);
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: (0, _clsx["default"])(_commonShareSocial["default"].icon, theme.mmcIconTwitter)
  })), facebookShareURL && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: _commonShareSocial["default"].shareBtn,
    onClick: function onClick() {
      return (0, _commonShareDialog2.openWindow)("https://www.facebook.com/sharer/sharer.php?" + facebookShareURL);
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: (0, _clsx["default"])(_commonShareSocial["default"].icon, theme.mmcIconFacebook)
  })));
};

CommonShareSocial.displayName = 'CommonShareSocial';
CommonShareSocial.defaultProps = {
  shareLabel: 'share'
};
var _default = CommonShareSocial;
exports["default"] = _default;